import { BaseExportModal, ExportModalProps } from './ExportModal'
import { COMPANIES_COLUMNS } from 'components/Tables/CompaniesTable/companiesColumnInfo'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { getCommonChainProxyExportColumns } from 'components/DataExpansionComponents/Common/commonExportColumns'
import { useDownload } from 'features/download-widget'
import { exportContactCompaniesV2, getDownloadStatus } from 'services/downloads'
import { useColumnStoreContext } from 'stores/ColumnsStore/useColumnsStoreContext'

export default function ContactCompanyExportModal(
  props: ExportModalProps & {
    subCategoryName: string
  }
) {
  const companyColumnHelper = createExportColumnHelper({
    columns: COMPANIES_COLUMNS,
  })

  const selectedColumns = useColumnStoreContext(
    (state) => state.selectedColumns
  )
  const { startDownload } = useDownload()

  const columns = [
    {
      title: 'Target Attributes',
      elements: [
        companyColumnHelper.retrieveColumn('name'),
        companyColumnHelper.retrieveColumn('domain'),
        companyColumnHelper.retrieveColumn('address'),
        companyColumnHelper.retrieveColumn('city'),
        companyColumnHelper.retrieveColumn('state'),
        companyColumnHelper.retrieveColumn('zipcode'),
        companyColumnHelper.retrieveColumn('country'),
        companyColumnHelper.retrieveColumn('created'),
        companyColumnHelper.retrieveColumn('category'),
        companyColumnHelper.retrieveColumn('type'),
      ],
    },
    {
      title: 'Account Details',
      elements: [...getCommonChainProxyExportColumns()],
    },
  ]

  const onSubmit = async (
    selectedCols: string[],
    exportType: 'csv' | 'xlsx'
  ) => {
    await startDownload({
      items: [{ id: 0, name: `Exporting ${props.subCategoryName}...` }],
      initiate: async () => {
        const { sort, ...filterWithoutSort } = (props.filters ?? {}) as Record<
          string,
          unknown
        >
        const response = await exportContactCompaniesV2({
          selected_columns: selectedCols,
          export_type: exportType,
          filter_params: {
            ...filterWithoutSort,
            include_ids: props.selectedIds ?? [],
            exclude_ids: props.excludeIds ?? [],
          },
          sort: sort as string | undefined,
        })
        return { type: 'async', requestId: response.request_id }
      },
      getStatus: getDownloadStatus,
      label: 'Custom Companies',
    })
  }

  return (
    <BaseExportModal
      title={`Select Columns for Unmatched ${props.subCategoryName} Download`}
      subTitle="Download up to 10,000 opportunities at a time, with any of the following columns. Any filters already applied will remain active."
      submitText="Export Companies"
      columns={columns}
      selectedColumns={selectedColumns}
      onSubmit={onSubmit}
      show={props.show}
      handleClose={props._handleClose}
    />
  )
}
